import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  productRegionOptions,
  ProductRegion,
} from "store/reducers/products/products.types";
import { Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ProcessState } from "types/process";
import { addNewProductAction } from "store/reducers/products/products.actions";
import { MAX_PRODUCTLINE_NAME_LENGTH } from "utils/file.util";

export const AddProductLineForm = ({
  handleRefreshProductlines,
  visible,
  handleCloseForm,
}: {
  handleRefreshProductlines: () => void;
  visible: boolean;
  handleCloseForm: () => void;
}) => {
  const dispatch = useDispatch();

  //State
  const [name, setName] = useState<string>("");
  const [region, setRegion] = useState<string>(ProductRegion.GLOBAL);
  const [processState, setProcessState] = useState<ProcessState>(
    ProcessState.IDLE
  );

  const clearProductLineInfo = () => {
    setName("");
    setRegion(ProductRegion.GLOBAL);
    setProcessState(ProcessState.IDLE);
  };

  const resetAllState = () => {
    setName("");
    setProcessState(ProcessState.IDLE);
    setRegion(ProductRegion.GLOBAL);
    clearProductLineInfo;
  };

  //Determine if we have gathered all the items necessary to do the import
  const isReady = processState === ProcessState.IDLE && name && region;

  useEffect(() => {
    if (!visible) {
      resetAllState();
    }
  }, [visible]);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleRegionChange = (event) => {
    setRegion(event.target.value);
  };

  //Request API to begin import of the productline
  const beginImport = async () => {
    setProcessState(ProcessState.INITIALIZING);

    try {
      //Add the productline
      await dispatch(
        addNewProductAction({
          name,
          region,
        })
      );

      handleCloseForm();

      setProcessState(ProcessState.COMPLETE);

      //Refresh productlines
      handleRefreshProductlines();
    } catch (error) {
      //A totally unexpected error happened.  Update state.
      console.error(
        error,
        `Error occurred while adding importing product line '${name}'`
      );
      setProcessState(ProcessState.ERROR);
    }
  };

  //If the form is not visible, don't bother rendering anything
  if (!visible) {
    return null;
  }

  return (
    <Grid
      container
      columnSpacing={1}
      rowSpacing={3}
      alignItems="center"
      style={{ marginLeft: "20px", marginRight: "20px" }}
    >
      <Grid xs={12}>
        <TextField
          label="Productline Name"
          value={name}
          id="productline-name"
          variant="outlined"
          size="small"
          fullWidth
          margin="none"
          onChange={handleNameChange}
          inputProps={{ maxLength: MAX_PRODUCTLINE_NAME_LENGTH }}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          label="Region"
          value={region}
          id="productline-region"
          variant="outlined"
          size="small"
          fullWidth
          margin="none"
          select
          SelectProps={{
            native: true,
          }}
          onChange={handleRegionChange}
        >
          {productRegionOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
      </Grid>
      <Grid xs={12}>
        <Button
          id="productline-import"
          variant="contained"
          size="large"
          fullWidth
          disabled={!isReady}
          onClick={beginImport}
        >
          Create Product Line
        </Button>
      </Grid>
    </Grid>
  );
};

export default AddProductLineForm;
